const serviceData = [
  {
    id: 1,
    title: "Airport Transfer",
    icon: "ri-flight-takeoff-line",
    desc: "With this being the center of our services, we offer transfer services to and from airports to your desired destination.",
  },
  {
    id: 2,
    title: "Pick and Drop",
    icon: "ri-map-pin-2-line",
    desc: "Kim Cab offers Pick n Drop services from any destination.",
  },
  {
    id: 2,
    title: "Fast & Easy Hotel Booking",
    icon: "ri-hotel-bed-fill",
    desc: "Kim Cab is well networked with a wide range of Hotels and Restaurants, anything you need.",
  },
  {
    id: 3,
    title: "Safari/Tour Consultant",
    icon: "ri-roadster-line",
    desc: "You can hola at us if you need assistance with information about Wild Safari and Tours.",
  },
  {
    id: 4,
    title: "City Transfers",
    icon: "ri-community-line",
    desc: "If you want to travel across the city or across the country Kim Cab has got your back.",
  },
  // {
  //   id: 5,
  //   title: "Hotel Booking Assistance",
  //   icon: "ri-map-pin-line",
  //   desc: "Tempor tempor sadipscing vero lorem sea, invidunt sed et eos ipsum et erat. Dolor ut duo sadipscing lorem. Gubergren gub",
  // },
];

export default serviceData;
